import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Paper from "components/Paper";
import Text from "components/Text";
import Button from "components/Button";
import clsx from "clsx";

import { writeToStorage } from "../../utils/storage";
import { QueryKeys } from "../../common/constants";
import { useGetDepartments } from "queries/department";

import styles from "./index.module.css";
const Step4 = () => {
    const history = useHistory();

    //-----------filters , state, handlers starts here --------------//
    const [deparmentId, setDeparmentId] = useState(null);
    //-----------------end of filter, state, handlers--------------------//

    //----------start data---------------//
    const { data, isLoading, isError } = useGetDepartments();
    //----------end data---------------//

    return (
        <div className={styles.step4Page}>
            <div className={styles.pageHeader}>
                <Text type={"h3"}>Pasul 1 din 5</Text>
                <Text type={"h1"}>
                    Pentru serviciile cărei Direcții ai nevoie de asistență?
                </Text>
            </div>
            <Paper className={styles.paper}>
                {data &&
                    !isLoading &&
                    !isError &&
                    data.map((deparment) => {
                        return (
                            <div
                                key={deparment?.id}
                                className={clsx(styles.card, styles.alignCenter, "mb-12", { [styles.activeItem]: deparmentId === deparment?.id })}
                                onClick={() => {
                                    setDeparmentId(deparment?.id);
                                    writeToStorage(QueryKeys.department, deparment?.abbreviation);
                                }}
                            >
                                {deparment?.abbreviation &&
                                    <Text type={"h3"} className={styles.cardItem1}>
                                        {deparment?.abbreviation}
                                    </Text>
                                }
                                {deparment?.name &&
                                    <Text type={"h3"} className={styles.cardItem2}>
                                        {deparment?.name}
                                    </Text>
                                }
                            </div>
                        );
                    })}
                <div
                    className={clsx(
                        styles.actionContainer,
                        styles.alignCenter,
                        styles.spaceBtw
                    )}
                >
                    <Button
                        className={styles.prevButton}
                        size="large"
                        variant="secondary"
                        label="<- înapoi"
                        onClick={() => history.push("/programare/step3")}
                    />
                    <Button
                        className={styles.nextButton}
                        size="large"
                        label="Continuă ->"
                        disabled={!deparmentId}
                        onClick={() => history.push(`/programare/step5?department_id=${deparmentId}`)}
                    />
                </div>
            </Paper>
        </div>
    );
};

export default Step4;
